import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ManageB2CDiscountComponent } from './manage-b2c-discount.component';
import { ToastModule } from 'primeng';

const routes: Routes = [
  { path: '', component: ManageB2CDiscountComponent, data: { title: 'Discount Lookup' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageB2CDiscountRoutingModule {}

@NgModule({
  imports: [
    ManageB2CDiscountRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ToastModule,
  ],
  declarations: [ManageB2CDiscountComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageB2CDiscountModule {}
